import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OfferRequestStatusEnum } from '../../../../models/offer.request.model';
import { TranslateService } from '@ngx-translate/core';
import { QuoteStatusEnum } from '../../../../models/quote.model';
import { PartnerStatus } from '../../../../models/partner.model';

@Component({
  selector: 'app-status-dropdown',
  templateUrl: './status-dropdown.component.html',
  styleUrls: ['./status-dropdown.component.css'],
  standalone: false
})
export class StatusDropdownComponent {

  @Input() status?: any;
  @Input() statusOptions: StatusOption[] = [];
  @Input() page: string = '';
  @Output() statusChanged = new EventEmitter<any>();
  @Input() optionsOfStatus: StatusOption[] = [];

  getStatusClass(): string {
    const option = this.statusOptions.find(opt => opt.value === this.status);
    return option ? option.class : '';
  }

  getStatusLabel(): string {
    const option = this.statusOptions.find(opt => opt.value === this.status);
    return option ? option.label : 'No status';
  }

  updateStatus(status: string): void {
    this.statusChanged.emit(status);
  }

  canChangeStatus(): boolean {
    if (!this.status) return false;
    if (this.page === 'review') {
      return true;
    }
    if (this.status == PartnerStatus.PENDING && this.page != 'quote') {
      return false;
    }
    if (this.page === 'quote') {
      return this.status === QuoteStatusEnum.PENDING;
    } else {
      return this.status === OfferRequestStatusEnum.PENDING ||
        this.status === OfferRequestStatusEnum.ACTIVE ||
        this.status === OfferRequestStatusEnum.APPROVED ||
        this.status === OfferRequestStatusEnum.REJECTED ||
        this.status === PartnerStatus.IN_REVIEW ||
        this.status === PartnerStatus.UPDATE_REQUIRED ||
        this.status === OfferRequestStatusEnum.SUSPENDED;
    }
  }
}

export interface StatusOption {
  label: string;
  value: any;
  class: string;
}
